import { protectedActionTest } from "@/api/test";
import { useMutation } from "@tanstack/react-query";

export const useProtectedActionTest = () => {
  return useMutation({
    mutationFn: protectedActionTest,
  });
};
